import styled from '@material-ui/styles/styled';
import { Header } from '@vkontakte/vkui';
import { HeaderProps } from '@vkontakte/vkui/dist/components/Header/Header';

export default styled(Header)({
  userSelect: 'none',
}) as React.FC<HeaderProps>;
